<template>
    <div class="form-floating mb-4">
        <select class="form-select" :id="id" @change="setValue($event)">
            <option v-if="getValue() === null" :selected="getValue() === null">Kies...</option>
            <option v-for="(item, i) in options" :value="item.value" :key="i" :selected="item.value === getValue()">{{ item.title }}</option>
        </select>
        <label :for="id">{{ title }}</label>
    </div>
</template>
<script>
export default {
    name:    'SelectField',
    props:   ['options', 'id', 'title'],
    methods: {
        setValue(event) {
            this.$store.commit('results/setQuestion', {
                id:    this.id,
                value: event.currentTarget.value
            })
        },
        getValue(event) {
            const question = this.$store.getters['results/getQuestionById'](this.id);

            if(question) {
                return question.value;
            }

            return null;
        }
    }
}
</script>
